'use client';
import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { useBinding } from '../../hooks/useBinding/useBinding.js';

function noop() {
  //
}
const RadioGroupContext = React.createContext({
  name: '',
  value: undefined,
  setValue: noop
});
const useRadioGroup = () => {
  const context = React.useContext(RadioGroupContext);
  if (!context.name) {
    throw new Error('useRadioGroup must be used within a RadioGroup');
  }
  return context;
};
function RadioGroupProvider({
  name,
  value,
  defaultValue,
  onChange = noop,
  children
}) {
  const [checkedValue, setValue] = useBinding(defaultValue, value, onChange, '');
  const nextValue = value !== null && value !== void 0 ? value : checkedValue;
  const context = React.useMemo(() => ({
    name,
    value: nextValue,
    setValue
  }), [name, nextValue, setValue]);
  return jsx(RadioGroupContext.Provider, {
    value: context,
    children: children
  });
}

export { RadioGroupContext, RadioGroupProvider, useRadioGroup };
//# sourceMappingURL=RadioGroupProvider.js.map
